import {
	FETCH_SALARIES_SUCCESS,
	FETCH_SALARY_SUCCESS,
} from "../../constants/ActionTypes";

const initialSettings = {};

export default (state = initialSettings, action) => {
	switch (action.type) {
		case FETCH_SALARIES_SUCCESS: {
			return { ...state, index: action.payload };
		}
		case FETCH_SALARY_SUCCESS: {
			return { ...state, show: action.payload };
		}
		default:
			return state;
	}
};
